import { graphql } from 'react-relay';

export const tritxRevokeCancel = graphql`
  mutation tritxRevokeCancelMutation($refundId: String!) {
    tritxRevokeCancel(refundId: $refundId) {
      result
      errors {
        code
        message
      }
    }
  }
`;
